import Icon from '../components/Icon.vue'

Icon.register({"question":{"width":384,"height":512,"paths":[{"d":"M202 0C122.2 0 70.5 32.7 29.9 91 22.6 101.6 24.8 116.1 35.1 123.9L78.2 156.6C88.6 164.5 103.4 162.6 111.5 152.5 136.5 121.1 155.1 103 194.2 103 225 103 263.1 122.8 263.1 152.6 263.1 175.2 244.4 186.8 214.1 203.8 178.6 223.7 131.8 248.4 131.8 310.2V320C131.8 333.3 142.5 344 155.8 344H228.2C241.5 344 252.2 333.3 252.2 320V314.2C252.2 271.4 377.5 269.6 377.5 153.6 377.5 66.3 286.9 0 202 0zM192 373.5C153.8 373.5 122.7 404.5 122.7 442.7 122.7 480.9 153.8 512 192 512S261.3 480.9 261.3 442.7 230.2 373.5 192 373.5z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/question.js
// module id = nwUj
// module chunks = 0